import {
  User,
  UserLoginPayload,
  ForgotPasswordPayload,
  ResetPasswordPayload,
  RegisterUserPayload,
  UpdateUserPayload,
  UpdatePasswordPayload,
  RefreshTokenPayload,
} from '@/types/index';
import api from '@/utils/api';

export const authenticate = async (payload: UserLoginPayload) =>
  api.post<{
    user: User;
    accessToken: string;
    refreshToken: string;
  }>('User/Authenticate', {
    data: payload,
  });

export const refreshToken = async (payload: RefreshTokenPayload) =>
  api.post<{
    user: User;
    accessToken: string;
    refreshToken: string;
  }>('User/RefreshToken', {
    data: {
      ...payload,
      refreshTokenData: payload,
    },
  });

export const forgotPassword = async (payload: ForgotPasswordPayload) =>
  api.post<{}>('User/ForgotPassword', {
    data: payload,
  });

export const resetPassword = async (payload: ResetPasswordPayload) =>
  api.post<{}>('User/ResetPassword', {
    data: payload,
  });

export const updatePassword = async (payload: UpdatePasswordPayload) =>
  api.put<{}>('User/UpdatePassword', {
    data: payload,
  });

export const register = async (payload: RegisterUserPayload) =>
  api.post<User>('User/WebRegistrationRequest', {
    data: payload,
  });

export const update = async (payload: UpdateUserPayload) =>
  api.put<{ user: User }>('User/Update', {
    data: payload,
  });
